import { HelpService } from '../../help/help.service';
import { Title } from '@angular/platform-browser';
import { GlobalConstants } from '../../../common/global-constants';
import { Component, OnInit, ViewChild } from "@angular/core";
import { ForecastService } from "../forecast.service";
import { ExportFilter, FilterInput, FilterMappingService, FilterOutput, FiltersOutput } from "src/app/models/filter-objects";
import { HtmlControlType } from "src/app/enums/htmlControlType";
import { DropdowndSelectedValues } from "src/app/widgets/dropdown-filter/dropdown-filter.component";

import { UtilsService } from "src/app/services/utils.service";
import { WindowService } from "src/app/services/window.service";
import { DxChartComponent, DxDataGridComponent } from 'devextreme-angular';
import { ShareDataService } from 'src/app/services/share-data.service';
import { ActivatedRoute } from '@angular/router';
import { TaskDataFilter } from '../../stock/stock.service';
import { TaskService } from '../../task/task.service';
import { DevTooltipCustComponent } from 'src/app/widgets';
import { BookmarkData } from 'src/app/models/Bookmark';
import { FileExportService } from 'src/app/common/file-export-service';
import { DxDataGridOperator } from 'src/app/operators/dx-data-grid.operator';

@Component({
	templateUrl: "./accuracy.component.html",
	styleUrls: ["./accuracy.component.scss"],
	standalone: false
})
export class AccuracyComponent implements OnInit {
	format = {
		type: "fixedPoint",
		precision: 0,
	};

	compactMode = false;

	gridColumns: { displayName: string; selectionName: string }[] = [];
	gridData: {
		[key: string]: string | number | boolean;
	}[] = [];

	filterOptions: FiltersOutput;
	htmlControlType = HtmlControlType;
	totalChartSource: any = [];
	accuracyChartSource: any = [];
	biasChartSource: any = [];
	errorChartSource: any = [];
	visualRange: any;

	filterList: FilterInput[] = [];
	appliedFilters: { [key: number]: string | string[] };

	faFinalForecast1color = "#ADB9CA";
	faFinalForecast2color = "#8FAADC";
	faFinalForecast3color = "#44546A";

	//dev express setting changes function for chart need on resize after windows size changes
	@ViewChild("totalChartChart", { static: false }) dxtotalChartChart: DxChartComponent;
	@ViewChild("accuracyChart", { static: false }) dxaccuracyChart: DxChartComponent;
	@ViewChild("biasChart", { static: false }) dxbiasChart: DxChartComponent;
	@ViewChild("errorChart", { static: false }) dxerrorChart: DxChartComponent;
	@ViewChild('scopeListDataGrid', { static: false }) dataScopeListGrid: DxDataGridComponent;

	constructor(
		private taskService: TaskService,
		private forecastService: ForecastService,
		private windowService: WindowService,
		private titleService: Title,
		private helpService: HelpService,
		private shareDataService: ShareDataService,
		private route: ActivatedRoute,
		private fileExportService: FileExportService
	) {
		this.shareDataService.CleanData();
	}

	taskFilterData: TaskDataFilter[];
	IsTaskLoad = false;
	ngOnInit(): void {
		this.titleService.setTitle("Accuracy");

		this.route.paramMap.subscribe(
			params => {
				const value = this.route.snapshot.queryParamMap.get("taskid");
				if (value) {

					//default load with parameters
					this.filterOptions = new FiltersOutput();
					this.filterOptions.action = "Filter";
					this.filterOptions.settingGroupId = 13; // 13 - Forecasting Accuracy Filter
					this.filterOptions.filters = [];
					this.appliedFilters = {};
					//loading filter data

					this.taskService.SelectTaskFilterValues(value).subscribe(data => {
						this.taskFilterData = data;
						this.taskFilterData.forEach(element => {
							let filteItem: FilterOutput = new FilterOutput();
							filteItem.fieldValue = element.settingValue;
							filteItem.settingId = element.settingId;
							this.filterOptions.filters.push(filteItem);
						});
						this.IsTaskLoad = true;
						this.getFiltersData();

					}, err => {
					});

				}
				else {
					this.filterOptions = new FiltersOutput();
					this.filterOptions.action = "Filter";
					this.filterOptions.settingGroupId = 13; // 13 - Forecasting Accuracy Filter
					this.filterOptions.filters = [];
					this.appliedFilters = {};
					this.dataFilter = new BookmarkData();
					this.dataFilter.BookmarkId = 0;
					this.dataFilter.name = "DefBokmk";
					this.dataFilter.pageName = this.pageName;
					this.loadBookMarkFilter();
				}
			});
		this.GetSettingsData();
		this.WebSettingsPivot();
	}

	//load filter data method
	private getFiltersData(skipFilters = false) {
		this.shareDataService.CleanData();
		this.shareDataService.filterOptions = this.filterOptions;
		this.ExportToExcelFilters = this.filterMappingService.mapFilterOutputMultiToFilterValue(this.filterOptions.filters);
		this.loadLengendToShare();
		let $this = this;

		this.forecastService
			.GetAccuracyFilters(this.filterOptions, skipFilters)
			.subscribe(
				(res) => {
					//convert received data to table structure for drop down
					res.forEach(item => {
						if (item.values) {
							item.values = item.values.map(all => ({ all }));
							if (item.defaultFilterValue != null && item.defaultFilterValue != undefined && item.values.length > 0) {
								item.selectedValues = [item.defaultFilterValue];
							}
						}
					});


					$this.filterList = res;
					for (let index = 0; index < this.filterList.length; index++) {
						if (this.filterList[index]) {
							let data = this.currentlySelectedFilters.filter(x => x.selectionId == this.filterList[index].selectionId);
							if (data && data.length > 0) {
								this.filterList[index].selectedValues = data[0].selectedValues;
							}
						}
					}

					if (this.IsTaskLoad) {
						this.IsTaskLoad = false;
						this.filterList.forEach(element => {
							let Data = this.taskFilterData.filter(x => x.settingId == element.selectionId);
							if (Data != null && Data.length > 0) {
								let arr = Data.map(function (item) {
									return item['settingValue'];
								});
								let newArry = [];
								arr.forEach(element => {
									let items = JSON.parse(element);
									items.forEach(elementItem => {
										newArry.push(elementItem);
									});
								});
								element.selectedValues = newArry;
							}
						});
					}

					if (this.isPageLoad) {
						this.isPageLoad = false;
						this.filterOptions.filters = [];
						this.filterList.forEach((item) => {
							if (item.selectedValues != null && item.selectedValues.length > 0) {
								this.filterOptions.filters.push({ fieldValue: JSON.stringify(item.selectedValues), settingId: item.selectionId });
							}
						});
					}
					this.LoadData();
				},
				(err) => {
					console.log(err);
				}
			);
	}

	onDataGridCellPrepared(e) {
		e.cellElement.style.padding = '5px';
	}

	private LoadData() {
		this.forecastService
			.GetAccuracyList(
				this.filterOptions.action,
				this.filterOptions.settingGroupId,
				this.filterOptions.filters
			)
			.subscribe(([columns, data]) => {
				this.gridColumns = columns || [];
				this.gridData = data;
				setTimeout(() => {
					this.LoadChartSeries();
				}, 1000);
			});

		this.forecastService
			.GetAccuracyData(
				this.filterOptions.action,
				this.filterOptions.settingGroupId,
				this.filterOptions.filters
			)
			.subscribe(
				(data) => {
					if (data) {
						this.totalChartSource = data.totalsChart || [];
						this.accuracyChartSource = data.accuracyChart || [];
						this.biasChartSource = data.biasChart || [];
						this.errorChartSource = data.errorChart || [];

						data.forecastChartCaption.forEach(itemCap => {
							if (this.dxtotalChartChart != null && this.dxtotalChartChart.series != null
								&& Array.isArray(this.dxtotalChartChart.series) && this.dxtotalChartChart.series.length > 0) {
								for (let index = 0; index < this.dxtotalChartChart.series.length; index++) {

									if (this.dxtotalChartChart.series[index].valueField != null
										&& (this.dxtotalChartChart.series[index].valueField.toLowerCase() == itemCap.fieldName.toLowerCase()
											|| this.dxtotalChartChart.series[index].name.toLowerCase() == itemCap.fieldName.toLowerCase())
									) {
										this.dxtotalChartChart.series[index].name = itemCap.captionName;
									}
								}
							}

							if (this.dxaccuracyChart != null && this.dxaccuracyChart.series != null
								&& Array.isArray(this.dxaccuracyChart.series) && this.dxaccuracyChart.series.length > 0) {
								for (let index = 0; index < this.dxaccuracyChart.series.length; index++) {
									if (this.dxaccuracyChart.series[index].valueField != null
										&& this.dxaccuracyChart.series[index].valueField.toLowerCase() == itemCap.fieldName.toLowerCase()) {
										this.dxaccuracyChart.series[index].name = itemCap.captionName;
									}
									this.dxaccuracyChart.series[index].visible = true;
								}

							}


							if (this.dxbiasChart != null && this.dxbiasChart.series != null
								&& Array.isArray(this.dxbiasChart.series) && this.dxbiasChart.series.length > 0) {
								for (let index = 0; index < this.dxbiasChart.series.length; index++) {
									if (this.dxbiasChart.series[index].valueField != null && this.dxbiasChart.series[index].valueField.toLowerCase() == itemCap.fieldName.toLowerCase()) {
										this.dxbiasChart.series[index].name = itemCap.captionName;
									}
									this.dxbiasChart.series[index].visible = true;
								}
							}

							if (this.dxerrorChart != null && this.dxerrorChart.series != null
								&& Array.isArray(this.dxerrorChart.series) && this.dxerrorChart.series.length > 0) {
								for (let index = 0; index < this.dxerrorChart.series.length; index++) {
									if (this.dxerrorChart.series[index].valueField != null && this.dxerrorChart.series[index].valueField.toLowerCase() == itemCap.fieldName.toLowerCase()) {
										this.dxerrorChart.series[index].name = itemCap.captionName;
									}
									this.dxerrorChart.series[index].visible = true;
								}
							}
						});

						//dynamic feild setting
						let VisibleElements = [];
						data.settingValue.forEach(settingItem => {

							if (settingItem.name.toLowerCase().includes("enabledisable")) {
								let ElementNameEnable = settingItem.name.toLowerCase();
								ElementNameEnable = ElementNameEnable.replace("enabledisable", "");
								if (settingItem.value.toLowerCase() == "no") {
									VisibleElements.push({ visible: false, showInLegend: true, SeriesName: ElementNameEnable });
								}
							}
							if (settingItem.name.toLowerCase().includes("enable")) {
								let ElementName = settingItem.name.toLowerCase();
								ElementName = ElementName.replace("enable", "");
								if (settingItem.value.toLowerCase() == "yes") {
									VisibleElements.push({ visible: true, showInLegend: true, SeriesName: ElementName });
								}
								else if (settingItem.value.toLowerCase() == "no") {
									VisibleElements.push({ visible: false, showInLegend: false, SeriesName: ElementName });
								}
							}

							if (settingItem.name.toLowerCase().includes("enableaccuracy")) {
								let ElementName = settingItem.name.toLowerCase();
								ElementName = ElementName.replace("enableaccuracy", "");
								if (settingItem.value.toLowerCase() == "yes") {
									VisibleElements.push({ visible: true, showInLegend: true, SeriesName: ElementName });
								}
								else if (settingItem.value.toLowerCase() == "no") {
									VisibleElements.push({ visible: false, showInLegend: false, SeriesName: ElementName });
								}
							}
						});
						if (Array.isArray(this.dxtotalChartChart.series)) {
							for (let index = 0; index < this.dxtotalChartChart.series.length; index++) {
								if (data != null && data.settingValue != null && data.settingValue.length > 0) {
									//enable/disbale
									if (this.dxtotalChartChart.series[index].valueField != null) {

										let ElemntExists = VisibleElements.filter(x => x.SeriesName == this.dxtotalChartChart.series[index].valueField.toLowerCase());
										if (ElemntExists != null && ElemntExists.length > 0) {
											if (ElemntExists.length > 1) {
												if (!ElemntExists[0].visible || !ElemntExists[1].visible) {
													this.dxtotalChartChart.series[index].visible = false;
												}
												else {
													this.dxtotalChartChart.series[index].visible = true;
												}

												if (!ElemntExists[0].showInLegend || !ElemntExists[1].showInLegend) {
													this.dxtotalChartChart.series[index].showInLegend = false;
												}
												else {
													this.dxtotalChartChart.series[index].showInLegend = true;
												}
											}
											else if (ElemntExists.length > 2) {
												if (!ElemntExists[0].visible || !ElemntExists[1].visible || !ElemntExists[2].visible) {
													this.dxtotalChartChart.series[index].visible = false;
												}
												else {
													this.dxtotalChartChart.series[index].visible = true;
												}

												if (!ElemntExists[0].showInLegend || !ElemntExists[1].showInLegend || !ElemntExists[2].showInLegend) {
													this.dxtotalChartChart.series[index].showInLegend = false;
												}
												else {
													this.dxtotalChartChart.series[index].showInLegend = true;
												}
											}
											else {
												this.dxtotalChartChart.series[index].visible = ElemntExists[0].visible;
												this.dxtotalChartChart.series[index].showInLegend = ElemntExists[0].showInLegend;
											}
										}
										else {
											if (!this.dxtotalChartChart.series[index].valueField.toLowerCase().includes("addon")) {
												this.dxtotalChartChart.series[index].visible = true;
												this.dxtotalChartChart.series[index].showInLegend = true;
											}
											if (this.dxtotalChartChart.series[index].valueField == 'released') {
												let ElemntExists = VisibleElements.filter(x => x.SeriesName.substring(8, x.SeriesName.length - 8) == this.dxtotalChartChart.series[index].valueField.toLowerCase());
												if (ElemntExists != null && ElemntExists.length > 0) {
													this.dxtotalChartChart.series[index].visible = ElemntExists[0].visible;
													this.dxtotalChartChart.series[index].showInLegend = ElemntExists[0].showInLegend;
												}
											}
											if (this.dxtotalChartChart.series[index].valueField == 'actualSales' || this.dxtotalChartChart.series[index].valueField == 'actualSalesLY') {
												let ElemntExists = VisibleElements.filter(x => x.SeriesName.substring(8, 0) == this.dxtotalChartChart.series[index].valueField.toLowerCase());
												if (ElemntExists != null && ElemntExists.length > 0) {
													this.dxtotalChartChart.series[index].visible = ElemntExists[0].visible;
													this.dxtotalChartChart.series[index].showInLegend = ElemntExists[0].showInLegend;
												}
											}
										}
									}
								}
							}
						}
						//accuracyChart-faFinalforecast1,faFinalforecast2,faFinalforecast3 legend
						if (Array.isArray(this.dxaccuracyChart.series)) {
							for (let index = 0; index < this.dxaccuracyChart.series.length; index++) {
								if (data != null && data.settingValue != null && data.settingValue.length > 0) {
									//enable/disbale
									if (this.dxaccuracyChart.series[index].valueField != null) {
										let ElemntExists = VisibleElements.filter(x => 'fa' + x.SeriesName == this.dxaccuracyChart.series[index].valueField.toLowerCase());
										if (ElemntExists != null && ElemntExists.length > 0) {
											this.dxaccuracyChart.series[index].visible = ElemntExists[0].visible;
											this.dxaccuracyChart.series[index].showInLegend = ElemntExists[0].showInLegend;
										}
									}
								}
							}
						}

						//biasChart-biasPosFinalForecast,biasNegFinalForecast legends
						if (Array.isArray(this.dxbiasChart.series)) {
							for (let index = 0; index < this.dxbiasChart.series.length; index++) {
								if (data != null && data.settingValue != null && data.settingValue.length > 0) {
									//enable/disbale
									if (this.dxbiasChart.series[index].valueField != null) {
										let ElemntExists = VisibleElements.filter(x => 'biaspos' + x.SeriesName == this.dxbiasChart.series[index].valueField.toLowerCase());
										if (ElemntExists != null && ElemntExists.length > 0) {
											this.dxbiasChart.series[index].visible = ElemntExists[0].visible;
											this.dxbiasChart.series[index].showInLegend = ElemntExists[0].showInLegend;
										}
										let ElemntExistsNeg = VisibleElements.filter(x => 'biasneg' + x.SeriesName == this.dxbiasChart.series[index].valueField.toLowerCase());
										if (ElemntExistsNeg != null && ElemntExistsNeg.length > 0) {
											this.dxbiasChart.series[index].visible = ElemntExistsNeg[0].visible;
											this.dxbiasChart.series[index].showInLegend = ElemntExistsNeg[0].showInLegend;
										}
									}
								}
							}
						}

						//ErrorChart-absFinalForecast legends
						if (Array.isArray(this.dxerrorChart.series)) {
							for (let index = 0; index < this.dxerrorChart.series.length; index++) {
								if (data != null && data.settingValue != null && data.settingValue.length > 0) {
									//enable/disbale
									if (this.dxerrorChart.series[index].valueField != null) {
										let ElemntExists = VisibleElements.filter(x => 'abs' + x.SeriesName == this.dxerrorChart.series[index].valueField.toLowerCase());
										if (ElemntExists != null && ElemntExists.length > 0) {
											this.dxerrorChart.series[index].visible = ElemntExists[0].visible;
											this.dxerrorChart.series[index].showInLegend = ElemntExists[0].showInLegend;
										}
									}
								}
							}
						}
						this.onResize();
						setTimeout(() => {
							this.LoadChartSeries();
						}, 1000);
					}
				},
				(err) => {
					console.log(err);
				}
			);
	}

	//window resize function  refresh all charts
	onResize() {
		setTimeout(() => {
			this.dxtotalChartChart.instance.refresh();
			this.dxaccuracyChart.instance.refresh();
			this.dxbiasChart.instance.refresh();
			this.dxerrorChart.instance.refresh();
		});
	}

	//hide and show series on click
	onLegendClickMainChart(e: any) {
		const series = e.target;
		let ShowHide = false;
		if (series.isVisible()) {
			series.hide();
		} else {
			series.show();

		}
		this.loadLengendToShare();
	}

	//adding percentage symbol in seasonality points
	customizeText = (info: any) => {

		return (info.value).toLocaleString() + "%";
	};

	customizeTooltip = (info: any) => {
		return DevTooltipCustComponent.customizeTooltip(info, "Year-Month", "", "");
	}


	customizeTooltipNew = (info: any) => {
		return DevTooltipCustComponent.customizeTooltipNewDecimalPlace(info, "Year-Month", "", "%", 2);
	}

	//on search button click
	applyFilters() {

		this.filterOptions.filters = [];

		let currentFilters: FilterInput[] = [];
		let filters: FilterOutput[] = [];
		//finding each data and pushing to this.filterOptions.filters variable
		if (this.filterList.filter(item => item.selectedValues).length > 0) {
			this.filterList.forEach(item => {
				if (item.selectedValues && item.selectedValues.length > 0) {

					const current = new FilterInput();
					current.selectionId = item.selectionId;
					current.selectedValues = item.selectedValues;
					currentFilters.push(current);
					let f = new FilterOutput();
					f.settingId = item.selectionId;
					f.fieldValue = JSON.stringify(item.selectedValues);
					filters.push(f);

				}
			}
			)
		}

		if (this.filterList.filter(item => item.selectedValues).length > 0) {
			this.filterList.forEach(item => {
				if (item.selectedValues && item.selectedValues.length > 0) {
					const current = new FilterInput();
					current.selectionId = item.selectionId;
					current.selectedValues = item.selectedValues;
					currentFilters.push(current);
				}
			}
			)
		}


		this.currentlySelectedFilters = currentFilters;
		this.filterOptions.filters = filters;
		this.getFiltersData();
	}

	//reseting filter data
	resetFilters() {

		this.appliedFilters = {};
		this.filterOptions.filters = [];
		this.IsTaskLoad = false;

		this.filterList.forEach((item) => {
			if (item.htmlControlType === HtmlControlType.Textbox) {
				item.selectedValue = "";
			} else if (item.defaultFilterValue) {
				item.selectedValues = [item.defaultFilterValue];

			} else {
				item.selectedValues = [];
			}
		});



		this.filterOptions.filters = [];

		let currentFilters: FilterInput[] = [];
		let filters: FilterOutput[] = [];
		//finding each data and pushing to this.filterOptions.filters variable
		if (this.filterList.filter(item => item.selectedValues).length > 0) {
			this.filterList.forEach(item => {
				if (item.selectedValues && item.selectedValues.length > 0) {

					const current = new FilterInput();
					current.selectionId = item.selectionId;
					current.selectedValues = item.selectedValues;
					currentFilters.push(current);
					let f = new FilterOutput();
					f.settingId = item.selectionId;
					f.fieldValue = JSON.stringify(item.selectedValues);
					filters.push(f);
				}
			}
			)
		}

		if (this.filterList.filter(item => item.selectedValues).length > 0) {
			this.filterList.forEach(item => {
				if (item.selectedValues && item.selectedValues.length > 0) {
					const current = new FilterInput();
					current.selectionId = item.selectionId;
					current.selectedValues = item.selectedValues;
					currentFilters.push(current);
				}
			}
			)
		}


		this.currentlySelectedFilters = currentFilters;
		this.filterOptions.filters = filters;
		this.ChartSettings = null;

		this.getFiltersData(true);
	}

	selectedItemsChanged({ selectionId, values }: DropdowndSelectedValues) {

		this.filterList
			.filter(item => item.selectionId === selectionId)
			.forEach(item => item.selectedValues = values);
	}

	isMultipleSelect(input: FilterInput): boolean {
		return input.htmlControlType === HtmlControlType.List;
	}

	setTextBoxFilterOptions(selectionId: number, { value }: any) {

	}

	getMarkerPath(item) {

		return UtilsService.getlegendMarkerPathNew(item, 'deepdive', GlobalConstants.SvgLinSettingsCollection.defaultSettingsNew);

	}

	goToDeepDive(data: { ForecastObjectClientId: string }) {
		this.windowService.openInNewPageWithoutSerializeUrl(
			"/forecast/deep-dive-new?id=" + UtilsService.getURLHelper(data.ForecastObjectClientId)
		);
	}

	onToolbarPreparing(e: any) {
		e.toolbarOptions.items.unshift({
			location: 'after',
			template: 'appliedFiltersButtonTemplate'
		}, {
			location: "before",
			template: "columnMode",
		}, {
			location: 'before',
			template: 'heightButtonTemplate'
		});
	}

	onToggleColumnsMode() {
		this.compactMode = !this.compactMode;


		let currentState = this.dataScopeListGrid.instance.state();
		currentState.columns.forEach(col => {
			delete col.width;
		});

		this.dataScopeListGrid.instance.state(currentState);
	}

	// private setFilterOption(
	//   selectionId: number,
	//   value: string | string[],
	//   type?: HtmlControlType
	// ) {








	public onHelpButtonClicked(event, settingName: string) {


		this.helpService.openHelpPage(settingName);
	}

	//bookmark code
	pageName: string = "ForecastAccuracyOverview";
	currentlySelectedFilters: FilterInput[] = [];
	dataFilter: BookmarkData;
	isPageLoad: boolean = false;

	loadBookMarkFilterClick(data) {
		if (data != null && data != undefined && data.bookmarkId != null && data.bookmarkId != undefined) {
			this.filterList.map(item => item.selectedValues = []);
			this.currentlySelectedFilters = [];
			this.IsTaskLoad = true;
			this.appliedFilters = {};
			this.filterOptions.filters = [];
			this.filterList.forEach((item) => {
				if (item.htmlControlType === HtmlControlType.Textbox) {
					item.selectedValue = "";
				} else if (item.defaultFilterValue) {
					item.selectedValues = [item.defaultFilterValue];

				} else {
					item.selectedValues = [];
				}
			});

			this.dataFilter = new BookmarkData();
			this.dataFilter.BookmarkId = data.bookmarkId;
			this.dataFilter.name = "Bokmk";
			this.dataFilter.pageName = this.pageName;
			this.loadBookMarkFilter();
		}
	}

	loadBookMarkFilter() {
		let filterData = Object.assign({}, this.dataFilter);
		filterData.name = "BokmkN";
		this.ChartSettings = null;
		this.taskService.LoadBookmarkData(filterData).subscribe(RData => {
			if (RData != null && RData.table != null && RData.table.length > 0) {
				this.IsTaskLoad = false;
				if (RData.table[0].chartSettings != null && RData.table[0].chartSettings != "") {
					this.ChartSettings = JSON.parse(RData.table[0].chartSettings);
				}
				this.LoadChartSeries();
				this.onResize();
				this.loadLengendToShare();
				this.taskService.LoadBookmarkFilter(this.dataFilter).subscribe(data => {
					this.taskFilterData = data;
					//default load with parameters
					this.filterOptions = new FiltersOutput();
					this.filterOptions.action = "Filter";
					this.filterOptions.settingGroupId = 13; // 13 - Forecasting Accuracy Filter
					this.filterOptions.filters = [];
					this.appliedFilters = {};
					//loading filter data

					this.taskFilterData.forEach(element => {
						let filteItem: FilterOutput = new FilterOutput();
						filteItem.fieldValue = element.settingValue;
						filteItem.settingId = element.settingId;
						this.filterOptions.filters.push(filteItem);
					});
					this.IsTaskLoad = true;
					this.getFiltersData();
				}, err => {
				});
			}
			else {
				this.isPageLoad = true;
				this.filterOptions = new FiltersOutput();
				this.filterOptions.action = "Filter";
				this.filterOptions.settingGroupId = 13; // 13 - Forecasting Accuracy Filter
				this.filterOptions.filters = [];
				this.appliedFilters = {};
				this.getFiltersData();
			}
		}, err => {
		});
	}

	/* Export Forecast Option */

	IsExportEnable = false;
	IsExportListEnable = false;
	GetSettingsData() {
		this.fileExportService.WebSettings("EnableExportForecastAccuracy").subscribe(resultFilename => {
			this.IsExportEnable = (resultFilename.value.toLowerCase() == "yes" ? true : false);
		}, err => {
			console.log(err);
		});
		this.fileExportService.WebSettings("EnableExportForecastAccuracylist").subscribe(resultFilename => {
			this.IsExportListEnable = (resultFilename.value.toLowerCase() == "yes" ? true : false);
		}, err => {
			console.log(err, "err");
		});
	}

	//tooltip
	EnableTooltip = false;
	ShowTooltip = false;
	WebSettingsPivot() {
		this.fileExportService.WebSettingsPivot("actionpivotForecastAccuracy").subscribe(result => {
			console.log(result);
			if (result != null && result.length > 0 && result[0].defaultSelectionTooltipForecastAccuracy != null
				&& result[0].defaultSelectionTooltipForecastAccuracy.toLowerCase() == "yes") {
				this.EnableTooltip = true;
			}
			if (result != null && result.length > 0 && result[0].enableDisableTooltipForecastAccuracy != null
				&& result[0].enableDisableTooltipForecastAccuracy.toLowerCase() == "yes") {
				this.ShowTooltip = true;
			}

		}, err => {
			console.log(err);
		});
	}

	loadLengendToShare() {

		let seriesValues = { TotalChartChart: [], AccuracyChart: [], BiasChart: [], ErrorChart: [], ScopeList: [] };
		if (this.dxtotalChartChart != null && this.dxtotalChartChart.instance != null
			&& this.dxtotalChartChart.instance.getAllSeries() != null) {
			this.dxtotalChartChart.instance.getAllSeries().forEach(item => {
				if (item.name != null && item["getValueFields"]() && item["getValueFields"]().length > 0) {
					seriesValues.TotalChartChart.push({ ValueField: item["getValueFields"]()[0], Name: item.name, isVisible: item.isVisible() });
				}
			})
		}

		if (this.dxaccuracyChart != null && this.dxaccuracyChart.instance != null
			&& this.dxaccuracyChart.instance.getAllSeries() != null) {
			this.dxaccuracyChart.instance.getAllSeries().forEach(item => {
				if (item.name != null && item["getValueFields"]() && item["getValueFields"]().length > 0) {
					seriesValues.AccuracyChart.push({ ValueField: item["getValueFields"]()[0], Name: item.name, isVisible: item.isVisible() });
				}
			})
		}

		if (this.dxbiasChart != null && this.dxbiasChart.instance != null
			&& this.dxbiasChart.instance.getAllSeries() != null) {
			this.dxbiasChart.instance.getAllSeries().forEach(item => {
				if (item.name != null && item["getValueFields"]() && item["getValueFields"]().length > 0) {
					seriesValues.BiasChart.push({ ValueField: item["getValueFields"]()[0], Name: item.name, isVisible: item.isVisible() });
				}
			})
		}
		if (this.dxerrorChart != null && this.dxerrorChart.instance != null
			&& this.dxerrorChart.instance.getAllSeries() != null) {
			this.dxerrorChart.instance.getAllSeries().forEach(item => {
				if (item.name != null && item["getValueFields"]() && item["getValueFields"]().length > 0) {
					seriesValues.ErrorChart.push({ ValueField: item["getValueFields"]()[0], Name: item.name, isVisible: item.isVisible() });
				}
			})
		}
		seriesValues.ScopeList = this.ScopeList;
		this.shareDataService.ChartSettings = JSON.stringify(seriesValues);
	}

	ChartSettings: any;
	LoadChartSeries() {
		if (this.ChartSettings != null) {

			if (this.ChartSettings.TotalChartChart != null && this.ChartSettings.TotalChartChart.length > 0) {
				if (this.dxtotalChartChart != null && this.dxtotalChartChart.series != null
					&& Array.isArray(this.dxtotalChartChart.series) && this.dxtotalChartChart.series.length > 0) {
					for (let index = 0; index < this.dxtotalChartChart.series.length; index++) {
						this.ChartSettings.TotalChartChart.forEach(itemchrt => {
							if (this.dxtotalChartChart.series[index].valueField != null
								&& itemchrt.isVisible != null && (this.dxtotalChartChart.series[index].valueField.toLowerCase() == itemchrt.ValueField.toLowerCase()
									|| this.dxtotalChartChart.series[index].name.toLowerCase() == itemchrt.ValueField.toLowerCase())
							) {
								this.dxtotalChartChart.series[index].visible = itemchrt.isVisible;
							}
						});
					}
				}
			}

			if (this.ChartSettings.AccuracyChart != null && this.ChartSettings.AccuracyChart.length > 0) {
				if (this.dxaccuracyChart != null && this.dxaccuracyChart.series != null
					&& Array.isArray(this.dxaccuracyChart.series) && this.dxaccuracyChart.series.length > 0) {
					for (let index = 0; index < this.dxaccuracyChart.series.length; index++) {
						this.ChartSettings.AccuracyChart.forEach(itemchrt => {
							if (this.dxaccuracyChart.series[index].valueField != null
								&& itemchrt.isVisible != null && (this.dxaccuracyChart.series[index].valueField.toLowerCase() == itemchrt.ValueField.toLowerCase()
									|| this.dxaccuracyChart.series[index].name.toLowerCase() == itemchrt.ValueField.toLowerCase())
							) {
								this.dxaccuracyChart.series[index].visible = itemchrt.isVisible;
							}
						});
					}
				}
			}

			if (this.ChartSettings.BiasChart != null && this.ChartSettings.BiasChart.length > 0) {
				if (this.dxbiasChart != null && this.dxbiasChart.series != null
					&& Array.isArray(this.dxbiasChart.series) && this.dxbiasChart.series.length > 0) {
					for (let index = 0; index < this.dxbiasChart.series.length; index++) {
						this.ChartSettings.BiasChart.forEach(itemchrt => {
							if (this.dxbiasChart.series[index].valueField != null
								&& itemchrt.isVisible != null && (this.dxbiasChart.series[index].valueField.toLowerCase() == itemchrt.ValueField.toLowerCase()
									|| this.dxbiasChart.series[index].name.toLowerCase() == itemchrt.ValueField.toLowerCase())
							) {
								this.dxbiasChart.series[index].visible = itemchrt.isVisible;
							}
						});
					}
				}
			}
			if (this.ChartSettings.ErrorChart != null && this.ChartSettings.ErrorChart.length > 0) {
				if (this.dxerrorChart != null && this.dxerrorChart.series != null
					&& Array.isArray(this.dxerrorChart.series) && this.dxerrorChart.series.length > 0) {
					for (let index = 0; index < this.dxerrorChart.series.length; index++) {
						this.ChartSettings.ErrorChart.forEach(itemchrt => {
							if (this.dxerrorChart.series[index].valueField != null
								&& itemchrt.isVisible != null && (this.dxerrorChart.series[index].valueField.toLowerCase() == itemchrt.ValueField.toLowerCase()
									|| this.dxerrorChart.series[index].name.toLowerCase() == itemchrt.ValueField.toLowerCase())
							) {
								this.dxerrorChart.series[index].visible = itemchrt.isVisible;
							}
						});
					}
				}
			}

			if (this.ChartSettings.ScopeList != null && this.ChartSettings.ScopeList.length > 0) {
				if (this.dataScopeListGrid != null && this.dataScopeListGrid.instance != null) {
					this.ChartSettings.ScopeList.forEach(element => {
						this.dataScopeListGrid.instance.beginUpdate();
						this.dataScopeListGrid.instance.columnOption(element.fieldName, 'filterType', 'include');
						if (element.filterType != null && element.filterType != undefined) {
							this.dataScopeListGrid.instance.columnOption(element.fieldName, 'filterType', element.filterType);
						}
						this.dataScopeListGrid.instance.columnOption(element.fieldName, 'filterValues', element.value);
						this.dataScopeListGrid.instance.endUpdate();
					});
				}
			}

		}
		this.onResize();
	}

	anyScopeTableActiveFilters = false;
	changeScopeTableActiveFiltersStatus() {
		if (this.anyScopeTableActiveFilters) {
			this.anyScopeTableActiveFilters = !this.anyScopeTableActiveFilters;
			this.dataScopeListGrid.instance.clearFilter();
			this.ScopeList = [];
			this.ChartSettings.ScopeList = [];
		}
	}

	public dxDataGridOperator: DxDataGridOperator = new DxDataGridOperator();

	public onDataGridContentReady(evt) {
		const curFilter = evt.component.getCombinedFilter();
		if (curFilter) {
			this.anyScopeTableActiveFilters = true;
		} else {
			this.anyScopeTableActiveFilters = false;
		}

		this.dxDataGridOperator.updateRowCount(evt.component);

		localStorage.setItem('grid-state-fc-accuracy', JSON.stringify(this.dataScopeListGrid.instance.state()));
	}

	ScopeList = [];
	saveState = (statenew) => {
		this.ScopeList = [];
		if (statenew != null && statenew.columns != null && statenew.columns.length > 0) {
			statenew.columns.forEach(element => {
				if (element.filterValues) {
					this.ScopeList.push({
						fieldName: element.dataField, filterType: element.filterType,
						value: element.filterValues
					});
				}
			});
		}
		this.loadLengendToShare();
	}
	filterMappingService = new FilterMappingService();
	ExportToExcelFilters: ExportFilter[] = [];
}
